module.exports = __webpack_public_path__ + "static/media/challengesidebarmenu.4aa704ae.png";